import React from 'react';
import { Box, Tooltip } from '@mantine/core';
import classes from './TourBeacon.module.css';
import { useTranslation } from 'react-i18next';

const TourBeacon: React.FC<any> = ( props ) => {
  const { t } = useTranslation( 'tour' );

  return (
    <Tooltip
      label={props.step.title ? `${props.step.title}` : t( 'beacon_open_tooltip', 'Click to resume tour' )}
      position="top"
      withArrow
      offset={8}
      className={classes.tooltip}
    >
      <Box className={classes.beaconContainer} onClick={props.onClick}>
        {/* Pulsing rings */}
        <div className={classes.pulseRing} />
        <div className={classes.pulseRing} />

        {/* Central dot */}
        <div className={classes.beacon} />

        {/* Soft glow */}
        <div className={classes.glow} />
      </Box>
    </Tooltip>
  );
};

export default TourBeacon;